import { render, staticRenderFns } from "./UserRegistrationView.vue?vue&type=template&id=029e1d6b&scoped=true&"
import script from "./UserRegistrationView.vue?vue&type=script&lang=js&"
export * from "./UserRegistrationView.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/item-list.css?vue&type=style&index=0&id=029e1d6b&prod&scoped=true&lang=css&"
import style1 from "./UserRegistrationView.vue?vue&type=style&index=1&id=029e1d6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029e1d6b",
  null
  
)

export default component.exports